import React, { useState, useEffect } from "react";
import {
  Box,
  Typography,
  Button,
  Divider,
  FormControl,
  InputAdornment,
  IconButton,
  styled,
  Stack,
  Input, TextField
} from "@mui/material";
import { useForm } from "react-hook-form";
import { ErrorMessage } from "@hookform/error-message";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import { addEneventGTM } from "../../../Utils/googleTags";
import {
  updateAuotPayEnroll
} from "../../../../../shared/hooks/useFetchPayment";
import ApiUrls from "../../../Utils/axr";
import useBrightspeedHeaders from "../../../hooks/useBrightspeedHeader";
import { useAppSelector, useAppDispatch } from "../../../hooks";
import {
  getlistOfPaymentMethods
} from "../../../SharedContextStore/slices/paymentMethods";
import {
  setDefaultPaymentId, setSinglePaymentloader
} from "../../../SharedContextStore/slices/paymentMethodDetails";
import closeIcon from "../../../assets/icon-close.svg";
import VisibilityIcon from "../../../assets/icon-view-on.png";
import VisibilityOffIcon from "../../../assets/icon-view-off.png";
import "../index.css";
import { EC_DW_LOGGING_STEPS } from "../../../../../shared/utils/Constants";
import { getquickBillPayPageContent } from "../../../SharedContextStore/slices/contents/qbpContentAem";
import { QuickBillPay } from "../../../SharedComponents/contents";
import { validateCVVSpeedPay } from "../../../Utils/validations-utils";
import DwLogutil from "../../../Utils/DwLogutil";
const InputCss = styled(Input)(({ theme }) => ({
  "label + &": {
    marginTop: 0,
    border: "1px solid #000",
  },
  "&.MuiInput-underline:after": {
    borderBottom: 0,
    textDecoration: "none",
  },
  "&.MuiInput-underline:before": {
    borderBottom: 0,
  },
}));

interface changePaymentProps {
  onClose: () => void;
  isPaypal: boolean;
  cardInfo: {
    cardNumber: string;
    expiryDate: string;
    cvv: string;
    isPrimaryPaymentMethod?: boolean;
    id: string;
    creditCardType: string;
    cardDetails: any;
  };
  resetRadioBtnSelect: Function;
  deletePrimaryPaymentMethod?: boolean;
  deleteSuccess: () => void;
  deletePayment?: string;
  deletePaymentMethodId?: string;
  apiStatus: Function;
}

const ChangeAutoPaymentMethodNew = (props: changePaymentProps) => {
  const user = useAppSelector((state) => state.user.data);
  const sessionId = useAppSelector((state) => state?.user?.sessionId);
  const globalToken = useAppSelector((state) => state?.brightspeedToken?.data);
  const userCompanyName = useAppSelector((state) => state?.user?.companyName);
  const { onClose, cardInfo, isPaypal, deleteSuccess, apiStatus } = props;
  const dispatch = useAppDispatch();
  const headers = useBrightspeedHeaders();
  const {
    nextPrimaryPaymnetId,
    defaultPayId,
    deletePaymentDetails,
    nextPrimaryMethod,
  } = useAppSelector((state) => state?.paymentMethodDetails);



  const QBP_CONTENT_Data: any = useAppSelector(
    (state) => state.quickBillPayContent?.quickBillPayPageContent
  );

  const QBP_CONTENT_2: any = QuickBillPay();
  
    useEffect(() => {
    if (!QBP_CONTENT_Data) {
      dispatch(getquickBillPayPageContent());
    }
  }, []);

  const changePaymentPrimaryMethod = QBP_CONTENT_2?.entry?.paymentMethodSection?.changePaymentPrimaryMethod;

  const [showPass, setShowPass] = useState(false);

  const updateCVVSchema = yup
  .object({
    cvv: yup
      .string()
      .required(changePaymentPrimaryMethod.cvvError)
      .matches(/^[0-9]{3}$/, changePaymentPrimaryMethod.cvvError)
      .nullable(),
  })
  .required();

  const {
    register,
    handleSubmit,
    formState: { errors },
    setError,
  } = useForm({
    resolver: yupResolver(updateCVVSchema),
    mode: "onBlur",
    defaultValues: {
      cvv: null,
    },
  });

  const {
    autoPaymentMethods: listOfAutoPaymentMethodRes,
    nextPrimaryPaymentMethod,
    selectDeletePrimaryPaymentMethod,
  } = useAppSelector((state) => state.paymentMethods);

  const handleMouseDownPassword = (
    event: React.MouseEvent<HTMLButtonElement>
  ) => {
    event.preventDefault();
  };

  const makeDefaultPaymentForCTL = async () => {
    try {
      const payload = {
        baseline: {
          siteId: headers?.siteId?.toLowerCase(),
        },
        paymentAuthId: nextPrimaryMethod?.id,
        creditAccount: user?.billingAccountNumber,
        emailAddress: user?.email,
        paymentChannelKind: "Web",
        debitName: `${user?.firstName} ${user?.lastName}`,
        paymentType: nextPrimaryMethod?.paymentType === "ACH" ? "ACH" : "card",
      };

      
      dispatch(setSinglePaymentloader(true));
      let url=ApiUrls["update_autopay"]
      const response = await updateAuotPayEnroll(
        {
          "": `${url}`,
        },
        payload,
        headers
      );
      if (response?.status === 200 && response?.data?.status === "Active") {
        if (nextPrimaryMethod?.id) {
          dispatch(setDefaultPaymentId(nextPrimaryMethod?.id));
        }
        user?.billingAccountNumber && dispatch(getlistOfPaymentMethods(user?.billingAccountNumber));
        DwLogutil({ stepName: EC_DW_LOGGING_STEPS.add_primary_payment})
        onClose();
        deleteSuccess();
        apiStatus("success");
        dispatch(setSinglePaymentloader(false));
      } else {
        apiStatus("fail");
        dispatch(setSinglePaymentloader(false));
      }
    } catch (error: any) {
      apiStatus("fail");
      dispatch(setSinglePaymentloader(false));
      DwLogutil({
        stepName: EC_DW_LOGGING_STEPS.add_primary_payment,
        error:
          error?.response?.data?.error_description ||
          error?.response?.data?.message ||
          changePaymentPrimaryMethod.wrong_changing_primary_method,
      })
    }
  };

  const onSubmit = async (data: any) => {
    if (data) {
      try{
            /* Validate the CVV */
            DwLogutil({ email: user?.email, stepName:EC_DW_LOGGING_STEPS?.AP_cvv_confirm_cta});
            const dataParams ={cvv:data?.cvv,
                expirationDate:props?.cardInfo?.expiryDate, 
                ApiUrls:ApiUrls.updatePaymentMethodUrl_QA,cardId:props?.cardInfo?.id,headers:headers,accountHolderName:props?.cardInfo?.cardDetails?.accountHolderInfo?.accountHolderName,banNumber:user?.billingAccountNumber,billingType:user?.billingType,email:user?.email};
              const response = await validateCVVSpeedPay(dataParams);
            if (response?.status === 200 && response?.data?.success === "true") {
                DwLogutil({ email: user?.email, stepName:EC_DW_LOGGING_STEPS?.AP_cvv_confirm_sucess});
                makeDefaultPaymentForCTL();
            }else{
              apiStatus("CVVfail");
              DwLogutil({ email: user?.email, stepName:EC_DW_LOGGING_STEPS?.AP_cvv_confirm_fail, error:"Something went wrong while changing primary payment method"});
            } 
      }catch(error: any) {
        apiStatus("CVVfail");
        DwLogutil({ email: user?.email, stepName:EC_DW_LOGGING_STEPS?.AP_cvv_confirm_fail, error:"Something went wrong while changing primary payment method"});
      }
      
    }
  };

  const handleGtEvent = () => {
    addEneventGTM(
      "EC_Primarycard_Popup_close_click",
      sessionId,
      user?.billingAccountNumber,
      userCompanyName
    );
    onClose();
  };

  return (
    <Stack id="cvvPopupContainer">
      <Box
        sx={{
          mx: { xs: "16px", sm: "40px" },
          mt: "64px",
          mb: "48px",
        }}
      >
        <Typography component="h2" id="confirmCVV-dialog-title"
          sx={{
            mb: "16px",
          }}
          className="cvvTitle"
        >
          {changePaymentPrimaryMethod?.title}
        </Typography>
        <Divider sx={{ mb: 2 }} role="presentation"/>
        <Typography
          sx={{ mt: "32px", mb: "40px"}}
          className="desc"
        >
          {changePaymentPrimaryMethod?.description}
        </Typography>
        <Typography component="h3"   
          sx={{ mb: "23px", fontWeight: "bold" }}
          className="cardTitle"
        >
          {changePaymentPrimaryMethod?.cardInfoTitle}
        </Typography>

        <Box id="confirmCVV-dialog-description"  
          sx={{
            width: { sm: "460px" },
          }}
        >
          <Box sx={{ display: "flex" }}>
            <FormControl variant="standard" sx={{ flex: 2 }}>
              <label htmlFor="fullName">
                {changePaymentPrimaryMethod?.cardNumberLabel}
              </label>
              
              <TextField
                className="fs-mask p-0 disabled-input-text"
                id="fullName"
                disabled
                variant="filled"
                value={`${props?.cardInfo?.creditCardType} ${props?.cardInfo?.cardNumber}`}                
              >          
              </TextField>
              
            </FormControl>
          </Box>
          <Box
            sx={{
              display: "flex",
              flexDirection: { xs: "column", sm: "row" },
              mt: "15px",
            }}
          >
            <FormControl
              className="cardExpiryDate"
              variant="standard"
              sx={{ my: 1 }}
            >
              <label htmlFor="expirationDate">
                {changePaymentPrimaryMethod?.expiryLabel}
              </label>
              <TextField
                  className="fs-mask p-0 disabled-input-text"
                  id="expirationDate"
                  disabled
                  variant="filled"
                  value={`${props?.cardInfo.expiryDate.slice(
                    0,
                    3
                  )}20${props?.cardInfo.expiryDate.slice(3, 5)}`}                                          
                >                  
                </TextField>  
            </FormControl>

            <FormControl
              variant="standard"
              className="cvvContainer"
              sx={{ my: 1 }}
            >
              <label htmlFor="cvvCode">
                {changePaymentPrimaryMethod?.cvvLabel}*
              </label>
              <InputCss
                className={
                  Object.keys(errors).length !== 0 &&
                  Object.keys(errors)?.includes("cvv")
                    ? "showErrorBorder_new fs-mask"
                    : "fs-mask"
                }
                disableUnderline={true}
                // id="cvv"
                aria-describedby="cvv-error cvv-txt"
                type={showPass ? "text" : "password"}
                {...register("cvv")}
                endAdornment={
                  <InputAdornment
                    position="end"
                    sx={{ position: "relative", right: "10px" }}
                  >
                    <IconButton
                       aria-label="cvv code"
                       aria-describedby="eye-toggle"
                       aria-pressed={showPass}        
                      onClick={() => setShowPass(!showPass)}
                      onKeyDown={(event) => {
                        if (event.key === 'Enter' || event.key === ' ') {
                          event.preventDefault();
                          setShowPass(!showPass)
                        }
                      }}
                      edge="end"
                      onMouseDown={handleMouseDownPassword}
                    >
                      {!showPass ? (
                            <span aria-label="hide CVV code" id="eye-toggle"><img src={VisibilityOffIcon} alt="" /></span>
                          ) : (
                            <span aria-label="show CVV code" id="eye-toggle"> <img src={VisibilityIcon} alt="" /></span>
                          )}
                    </IconButton>
                  </InputAdornment>
                }
                defaultValue=""
                id="cvvCode"
                // inputProps={{ maxLength: 3, minLength: 3 }} // keep length 3 as of now for cvv
                inputProps={{
                  "aria-invalid":
                    errors && Object.keys(errors)?.includes("cvv") ? "true" : "false",
                  "aria-required": true,
                  maxLength: 3, minLength: 3
                }}  
                placeholder={
                  changePaymentPrimaryMethod?.cvvCodePlaceholderLabel
                }
                onKeyPress={(e: any) => {
                  if (!/[0-9]/.test(e.key)) {
                    e.preventDefault();
                  }
                }}
              />
              <ErrorMessage
                errors={errors}
                name="cvv"
                render={({ message }) => (
                  <Box className="errorMsgFormat"  id="cvv-error">
                    <span className="inputFiledErrorImg"></span>
                    <span className="inputFiledErrorMsg">{message}</span>
                  </Box>
                )}
              />
            </FormControl>
          </Box>

          <Typography
            className="cvvRequired"
            sx={{
              fontSize: "12px !important",
              color: "#646464",
              mt: "8px",
              mb: "26px",
            }}
          >
            {changePaymentPrimaryMethod?.required}
          </Typography>

          <Box
            sx={{
              display: "flex"
            }}
          >
            <Button
              variant="outlined"
              color="primary"
              className="cvvCancelBtn"
              sx={{ flex: { md: "1" } }}
              onClick={() => {
                addEneventGTM(
                  changePaymentPrimaryMethod?.cancelBtnLabel,
                  sessionId,
                  user.billingAccountNumber,
                  userCompanyName
                );
                onClose();
              }}
            >
              {changePaymentPrimaryMethod?.cancelBtnLabel}
            </Button>
            <Button
              variant="contained"
              color="primary"
              onClick={handleSubmit(onSubmit)}
              className="cvvConfirmBtn"
              sx={{ flex: { md: "1" }, mr: { md: 0 } }}
            >
              {changePaymentPrimaryMethod?.confirmBtnLabel}
            </Button>
          </Box>
        </Box>
      </Box>
       <Stack
        className="new-close-icon-cantainer"
        direction="row"
        justifyContent="end"      
      >
        <Typography component="button" className="buttonText" onClick={handleGtEvent}
         aria-label="Close the dialog">
        <img
          src={closeIcon}
          alt="close icon"
          className="cursor-pointer"          
        />
        </Typography>
      </Stack>
    </Stack>
  );
};
export default ChangeAutoPaymentMethodNew;
